<div class="card" id="sale-recap">
    
    <div class="card-body">
        <div class="title-bar">
            <h2 class="card-title">Sale Recap</h2>
        </div>
        @if (sale) {
            <ul class="recap">
                <li>
                    <span>{{sale.stage === 'Sale' ? 'Sold' : 'Quoted'}}</span>
                    <span class="numeric">{{sale.saleDate | date:'E MMM d, yyyy'}}</span>
                </li>
                @if ((sale.accessories > 0) || (sale.tradeAllowance > 0)) {
                <li>
                    <span>Sale Price</span>
                    <span class="numeric">{{sale.salePrice | currency }}</span>
                </li>
                }
                @if (sale.accessories > 0) {
                    <li>
                        <span>Accessories</span>
                        <span class="numeric">{{sale.accessories || 0 | currency }}</span>
                    </li>
                }
                @if (sale.tradeAllowance > 0) {
                    <li>
                        <span class="text-danger">LESS: Trade Allowance</span>
                        <span class="numeric">{{sale.tradeAllowance || 0 | currency }}</span>
                    </li>
                }
                <li class="subtotal">
                    <span>Total Sale Price</span>
                    <span class="numeric">{{sale.totalSalePrice | currency }}</span>
                </li>
                @for (key of feeKeys; track key) {
                    @if (fees[key] > 0) {
                        <li>
                            <span>
                                {{key}}
                                @if (key === 'Inventory Tax') {
                                    ({{sale.inventoryTaxType}})
                                }
                            </span>
                            <span class="numeric">{{fees[key] | currency }}</span>
                        </li>
                    }
                }
                @if (sale.products > 0) {
                    <li>
                        <span>Products</span>
                        <span class="numeric">{{sale.products || 0 | currency }}</span>
                    </li>
                }
                <li class="subtotal">
                    <span>Drive-Out Price</span>
                    <span class="numeric">{{sale.driveOutPrice | currency }}</span>
                </li>
                @if (sale.tradePayoff > 0) {
                    <li>
                        <span>Trade Payoff</span>
                        <span class="numeric">{{sale.tradePayoff | currency }}</span>
                    </li>
                }
                @if (sale.downs) {
                    <li>
                        <span class="text-danger">LESS: Down Payments</span>
                        <span class="numeric">{{sale.downs | currency }}</span>
                    </li>
                }
                <li class="total">
                    <span>
                        Amount To 
                        @if (sale.financed) {
                            Finance
                        }
                        @else {
                            Pay
                        }
                    </span>
                    <span class="numeric">{{(sale.driveOutPrice + sale.tradePayoff - sale.downs) | currency }}</span>
                </li>
            </ul>
        }
    </div>
    <div class="card-footer">
        @if (sale && sale.id) {
            <div href="#" [routerLink]="['/sales', sale.id]" class="alert alert-secondary">Sale</div>
            <div href="#" [routerLink]="['/inventory', sale.inventoryId]" class="alert alert-secondary">Inventory</div>
            <div href="#" [routerLink]="['/contacts', sale.contactId]" class="alert alert-secondary">Contact</div>
        }
    </div>
</div>
